// extracted by mini-css-extract-plugin
export default {"popup":"errorPopup_popup__dzCsC","popup__title":"errorPopup_popup__title__79evM","popup__img":"errorPopup_popup__img__WZss5","popup__nextBtn":"errorPopup_popup__nextBtn__hK9kr"};